import React from 'react';
import {useIntl} from 'react-intl';
import messages from '../../../res/translations/messages';

const LocaleOptions = () => {
    const intl = useIntl();
    return (
        <>
            <option value="it-IT">{intl.formatMessage(messages.languages.it)}</option>
            <option value="en-EN">{intl.formatMessage(messages.languages.en)}</option>
            <option value="de-DE">{intl.formatMessage(messages.languages.de)}</option>
            <option value="es-ES">{intl.formatMessage(messages.languages.es)}</option>
            <option value="fr-FR">{intl.formatMessage(messages.languages.fr)}</option>
        </>
    );
};

export default LocaleOptions;
